module.exports = __webpack_public_path__ + "static/media/page_v2_1.075a5a4c.jpg";